import React from "react";
import styled from "styled-components";
import { Typography } from "../../general/Typography";

export interface BadgeLabelProps {
  label: string;
  variant?: "default" | "info" | "success" | "warning" | "error";
  size?: "sm" | "md";
}

const Wrapper = styled.span<{ variant: string; size: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ size, theme }) =>
    size === "sm" ? theme.typography.caption.fontSize : theme.typography.bodySmall.fontSize};
  font-weight: ${({ theme }) => theme.fonts.fontWeightMedium};
  padding: ${({ size, theme }) =>
    size === "sm" ? `${theme.spacing.xxs} ${theme.spacing.xs}` : `${theme.spacing.xs} ${theme.spacing.sm}`};
  border-radius: ${({ theme }) => theme.radii.lg};
  color: ${({ theme }) => theme.colors.textPrimary};
  background-color: ${({ variant, theme }) =>
    variant === "success" ? theme.colors.success :
    variant === "info" ? theme.colors.info :
    variant === "warning" ? theme.colors.warning :
    variant === "error" ? theme.colors.error :
    theme.colors.primary};
  white-space: nowrap;
`;

export const BadgeLabel: React.FC<BadgeLabelProps> = ({
  label,
  variant = "default",
  size = "sm",
}) => {
  return <Wrapper variant={variant} size={size}>
    <Typography
        variant={size === "sm" ? "overline" : "caption"}
        weight="medium"
        color="textOnDark"
        as="span"
      >
        {label}
      </Typography>
  </Wrapper>;
};